import { AbstractControl, AsyncValidator, AsyncValidatorFn, NG_ASYNC_VALIDATORS, ValidationErrors } from '@angular/forms';
import { Directive, forwardRef, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Observable } from 'rxjs';

import { existsInContract } from './validator';
import { GetParticipantsUseCase } from '../../../core';
import { Id } from '../../domain/data';

// noinspection JSAnnotator
@Directive({
    selector: '[existsInContract][formControlName],[existsInContract][formControl],[existsInContract][ngModel]',
    providers: [
        {
            provide: NG_ASYNC_VALIDATORS,
            useExisting: forwardRef(() => ExistsInContractValidatorDirective),
            multi: true,
        },
    ],
})
export class ExistsInContractValidatorDirective implements AsyncValidator, OnChanges, OnInit {
    private validator: AsyncValidatorFn;

    @Input()
    clientId: Id;

    @Input()
    field: string;

    @Input()
    otherValue: string;

    constructor(private getParticipantsUseCase: GetParticipantsUseCase) {}

    ngOnInit() {
        this.validator = existsInContract(this.clientId, this.field, this.otherValue, this.getParticipantsUseCase);
    }

    ngOnChanges(changes: SimpleChanges) {
        if ('clientId' in changes || 'field' in changes || 'otherValue' in changes) {
            this.validator = existsInContract(this.clientId, this.field, this.otherValue, this.getParticipantsUseCase);
        }
    }

    validate(c: AbstractControl): Promise<ValidationErrors | null> | Observable<ValidationErrors | null> {
        return this.validator(c);
    }
}
